import { render, staticRenderFns } from "./FinalizarNivelPage.vue?vue&type=template&id=416fc2d5&scoped=true&"
import script from "./FinalizarNivelPage.vue?vue&type=script&lang=js&"
export * from "./FinalizarNivelPage.vue?vue&type=script&lang=js&"
import style0 from "./FinalizarNivelPage.vue?vue&type=style&index=0&id=416fc2d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416fc2d5",
  null
  
)

export default component.exports